import { render, staticRenderFns } from "./NewComment.vue?vue&type=template&id=18cfc36c&"
import script from "./NewComment.vue?vue&type=script&lang=js&"
export * from "./NewComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18cfc36c')) {
      api.createRecord('18cfc36c', component.options)
    } else {
      api.reload('18cfc36c', component.options)
    }
    module.hot.accept("./NewComment.vue?vue&type=template&id=18cfc36c&", function () {
      api.rerender('18cfc36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments/NewComment.vue"
export default component.exports